var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"companyClientLayout",staticClass:"company-home"},[_c('company-header',{staticClass:"header-box"}),_c('router-view',{staticClass:"container-box",attrs:{"id":"container-box"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }